module.exports = __webpack_public_path__ + "img/ic_logout.143ef0db.svg";